import * as classNames from "classnames";
import * as React from "react";
import * as s from "./Loader.sss";
export function Loader(props) {
    const { className } = props;
    return (React.createElement("span", { className: classNames(s.loader, className) }));
}
